import React, { useState } from 'react';
import { QrCode, Notifications, AccountCircle, Logout } from '@mui/icons-material';
import { QRCodeSVG } from 'qrcode.react';
import { useNavigate } from 'react-router-dom';
import { getPaymentTerminalPayUrl } from '../../services/paymentService';

const CaissierHeader = ({ caissierData, unreadCount, onNotificationsClick, terminal }) => {
    const navigate = useNavigate();
    const [showQR, setShowQR] = useState(false);
    const { logout } = require('../../contexts/AuthContext').useAuth?.() || { logout: () => navigate("/") };

    const handleLogout = async () => {
        if (logout) {
            await logout();
        } else {
            navigate("/");
        }
    };

    // Utiliser les données réelles ou fallback
    const displayCaissierData = caissierData || {
        name: 'Caissier',
        terminalId: terminal?.tag || 'N/A',
        qrCode: getPaymentTerminalPayUrl(terminal?.tag) || '',
    };

    const qrCodeValue =
        displayCaissierData.qrCode?.includes('/payment-terminals/')
            ? displayCaissierData.qrCode
            : getPaymentTerminalPayUrl(displayCaissierData.qrCode || terminal?.tag);

    return (
        <header className="bg-white/80 backdrop-blur-lg border-b border-gray-200 sticky top-0 z-50">
            <div className="px-6 py-4">
                <div className="flex items-center justify-between">
                    {/* Identité du Caissier */}
                    <div className="flex items-center space-x-4">
                        <button
                            onClick={() => setShowQR(!showQR)}
                            className="flex items-center space-x-3 p-3 bg-gradient-to-r from-amber-500 to-amber-600 text-white rounded-2xl hover:from-amber-600 hover:to-amber-700 transition-all duration-300 shadow-lg hover:shadow-xl"
                        >
                            <QrCode className="text-white" />
                            <div className="text-left">
                                <div className="font-semibold text-sm">{displayCaissierData.name}</div>
                                <div className="text-amber-100 text-xs">{displayCaissierData.terminalId}</div>
                            </div>
                        </button>

                        {/* QR Code Modal */}
                        {showQR && (
                            <div className="absolute top-20 left-6 bg-white rounded-2xl shadow-2xl border border-amber-200 p-6 z-50">
                                <div className="text-center">
                                    <h3 className="font-bold text-gray-900 mb-3">Votre QR Code Caissier</h3>
                                    <div className="bg-white p-4 rounded-xl border-2 border-amber-300 inline-block">
                                        <QRCodeSVG
                                            value={qrCodeValue}
                                            size={180}
                                            level="H"
                                            includeMargin
                                            className="rounded-lg"
                                        />
                                    </div>
                                    <p className="text-sm text-gray-600 mt-3 max-w-xs">
                                        Scannez ce code pour identifier votre terminal de paiement
                                    </p>
                                    <button
                                        onClick={() => setShowQR(false)}
                                        className="mt-4 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm"
                                    >
                                        Fermer
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Actions Droites */}
                    <div className="flex items-center space-x-4">
                        {/* Bouton Notifications */}
                        <button
                            onClick={onNotificationsClick}
                            className="relative p-3 text-gray-600 hover:text-amber-600 transition-colors rounded-xl hover:bg-amber-50"
                        >
                            <Notifications />
                            {unreadCount > 0 && (
                                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center animate-pulse">
                                    {unreadCount}
                                </span>
                            )}
                        </button>

                        {/* Profil Caissier */}
                        <div className="flex items-center space-x-3 p-2 rounded-xl hover:bg-gray-100 transition-colors cursor-pointer">
                            <div className="w-10 h-10 bg-gradient-to-r from-amber-500 to-amber-600 rounded-full flex items-center justify-center">
                                <AccountCircle className="text-white" />
                            </div>
                            <div className="text-left">
                                <div className="font-semibold text-gray-900 text-sm">{displayCaissierData.name}</div>
                                <div className="text-gray-500 text-xs">Caissier</div>
                            </div>
                        </div>

                        {/* Déconnexion */}
                        <button
                            onClick={handleLogout}
                            className="p-3 text-gray-400 hover:text-red-500 transition-colors rounded-xl hover:bg-red-50"
                            title="Déconnexion"
                        >
                            <Logout />
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default CaissierHeader;